import React from 'react';
import {
    Box,
    Button,
    styled,
    Typography,
    GlobalStyles,
    keyframes,
    useTheme,
    useMediaQuery
} from '@mui/material';
import { Link } from 'react-router-dom';
import bg from '../../assets/backgroundLanding.webp';

// Keyframes para animar el subrayado
const highlightAnimation = keyframes`
    0% {
        width: 0;
    }
    100% {
        width: 100%;
    }
`;

// Estilo del contenedor principal
const CustomBox = styled(Box)(({ theme }) => ({
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: theme.spacing(5),
    backgroundImage: `url(${bg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'right center',
    position: 'relative',
}));

// Estilo del contenedor difuminado
const BlurContainer = styled(Box)(({ theme }) => ({
    background: 'rgba(255, 255, 255, 0.7)',
    backdropFilter: 'blur(8px)',
    borderRadius: '20px',
    padding: theme.spacing(4),
    maxWidth: '600px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
    },
    [theme.breakpoints.up('sm')]: {
        textAlign: 'left',
    },
}));

const Highlight = styled('span')(({ theme }) => ({
    position: 'relative',
    fontWeight: 800,
    color: 'rgb(41, 54, 54)',
    '&::after': {
        content: '""',
        position: 'absolute',
        left: 0,
        bottom: -2,
        width: '0%',
        height: '8px',
        background: 'rgba(113, 136, 149, 0.5)',
        borderRadius: '4px',
        animation: `${highlightAnimation} 1s ease-out forwards`,
    }
}));

// Botón estilizado
const CTAButton = styled(Button)(({ theme }) => ({
    fontWeight: 600,
    color: '#fff',
    backgroundColor: 'rgb(51, 64, 64)',
    borderRadius: '10px',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: 'rgb(41, 54, 54)',
      transform: 'scale(1.05)',
      boxShadow: '0 6px 20px rgba(0, 0, 0, 0.3)',
    },
  }));
  


const Header = () => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <>
            <GlobalStyles
                styles={{
                    'html, body': { margin: 0, padding: 0, overflowX: 'hidden' },
                    '*': { boxSizing: 'border-box' },
                }}
            />
            <CustomBox component="header">
                <BlurContainer>
                    <Typography
                        variant="h2"
                        component="h1"
                        sx={{
                            fontWeight: 800,
                            color: 'rgb(41, 54, 54)',
                            textShadow: '1px 1px 5px rgba(0, 0, 0, 0.2)',
                            fontSize: isSmallScreen ? '2rem' : '3rem',
                            marginBottom: 2,
                        }}
                    >
                        Formando Médicos
                    </Typography>
                    <Typography
                        variant="h3"
                        component="h2"
                        sx={{
                            fontWeight: 800,
                            fontSize: isSmallScreen ? '1.8rem' : '2.5rem',
                            marginBottom: 2,
                            display: 'inline-block',
                        }}
                    >
                        <Highlight>Ultrasonografistas</Highlight>
                    </Typography>
                    <Typography
                        variant="body1"
                        component="p"
                        sx={{
                            lineHeight: 1.6,
                            color: '#2c3e50',
                            fontSize: isSmallScreen ? '0.9rem' : '1.2rem',
                            marginBottom: 3,
                        }}
                    >
                        Capacítate con los mejores profesionales y lleva tu conocimiento al siguiente nivel.
                    </Typography>
                    <CTAButton
                        component={Link}
                        to="/about"
                        sx={{
                            px: isSmallScreen ? 3 : 4,
                            py: isSmallScreen ? 1 : 1.5,
                            fontSize: isSmallScreen ? '0.9rem' : '1rem',
                        }}
                        >
                        Ver diplomados disponibles
                    </CTAButton>
                </BlurContainer>
            </CustomBox>
        </>
    );
};

export default React.memo(Header);
